module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.13971/js/hsocImages/flower_coins.svg"